"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _restArguments = _interopRequireDefault(require("./restArguments.js"));
var _isFunction = _interopRequireDefault(require("./isFunction.js"));
var _negate = _interopRequireDefault(require("./negate.js"));
var _map = _interopRequireDefault(require("./map.js"));
var _flatten = _interopRequireDefault(require("./_flatten.js"));
var _contains = _interopRequireDefault(require("./contains.js"));
var _pick = _interopRequireDefault(require("./pick.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// Return a copy of the object without the disallowed properties.
var _default = exports.default = (0, _restArguments.default)(function (obj, keys) {
  var iteratee = keys[0],
    context;
  if ((0, _isFunction.default)(iteratee)) {
    iteratee = (0, _negate.default)(iteratee);
    if (keys.length > 1) context = keys[1];
  } else {
    keys = (0, _map.default)((0, _flatten.default)(keys, false, false), String);
    iteratee = function (value, key) {
      return !(0, _contains.default)(keys, key);
    };
  }
  return (0, _pick.default)(obj, iteratee, context);
});